// extracted by mini-css-extract-plugin
export var container = "layout-module--container--24dc1";